import type { AlertProps } from "@amzn/storm-ui";

import { zustandStore } from "../store/zustand.helpers";

export type AlertType = AlertProps["variant"];
export interface AlertState {
    message: string;
    type: AlertType;
    stack: string | undefined;
}

export interface AlertActions {
    setAlert: (message: string, type: AlertType, stack?: any) => void;
    resetAlert: () => void;
}

export const initialState: AlertState = {
    message: "",
    type: "info",
    stack: "",
};

export const { store: alertStore } = zustandStore<AlertState, AlertActions>(
    "Alert",
    initialState,
    (set: any) => ({
        setAlert: (message: string, type: AlertType, stack = {}) =>
            set(() => ({
                message,
                type,
                stack,
            })),
        resetAlert: () => set(() => ({ ...initialState })),
    }),
);
